<template>
  <section class="tool-page">
    <header class="tool-header">
      <div class="tool-emoji">🔗</div>
      <h1>Shorten a link</h1>
      <p>Turn any long URL into a short link with a QR code — claim and track it whenever you want.</p>
    </header>
    <ShortenTool />
  </section>
</template>

<script>
import ShortenTool from '@/components/tools/ShortenTool.vue';

export default {
  name: 'ShortenView',
  components: { ShortenTool },
};
</script>

<style scoped>
.tool-page {
  max-width: 640px;
  margin: 0 auto;
  padding: clamp(24px, 5vw, 56px) clamp(16px, 4vw, 40px) 80px;
}
.tool-header { text-align: center; margin-bottom: 28px; }
.tool-emoji {
  width: 52px;
  height: 52px;
  border-radius: var(--radius);
  background: var(--accent-soft);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin: 0 auto 14px;
}
.tool-header h1 {
  font-size: clamp(26px, 4vw, 38px);
  font-weight: 400;
  letter-spacing: -.01em;
  margin: 0 0 8px;
  color: var(--text);
}
.tool-header p { color: var(--muted); font-size: 15px; margin: 0 auto; max-width: 440px; }
</style>
